import { useState } from "react";
import { C, Section, KPI, Banner } from "./ui.jsx";

/* Read-only parallel comparison. Paste legacy rows as a JSON array; calls the
 * backend /api/birthday/parallel-compare (no production writes). */
export default function ComparePanel({ api, defaultDate }) {
  const [date, setDate] = useState(defaultDate);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [report, setReport] = useState(null);

  async function run() {
    setError(null); setReport(null);
    let rows;
    try {
      rows = JSON.parse(text);
      if (!Array.isArray(rows)) throw new Error("Expected a JSON array of legacy rows.");
    } catch (e) { setError("Invalid JSON: " + e.message); return; }
    setLoading(true);
    try {
      const r = await api.parallelCompare({ date, legacyRows: rows });
      setReport(r);
    } catch (e) { setError(e.message); }
    setLoading(false);
  }

  const inputStyle = { padding: "8px 10px", border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, outline: "none" };
  const s = report?.summary;

  return (
    <Section title="Parallel run comparison" sub="Compare legacy (Google Sheet / n8n) rows against Nexus candidates for a date. Read-only." style={{ marginTop: 20 }}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={inputStyle} />
        <button onClick={run} disabled={loading || !text.trim()}
          style={{ padding: "8px 16px", background: loading || !text.trim() ? C.border : C.accent, color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading || !text.trim() ? "default" : "pointer" }}>
          {loading ? "Comparing…" : "Run comparison"}
        </button>
        <span style={{ fontSize: 11.5, color: C.muted }}>Backend call · no writes · no sends</span>
      </div>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder='Paste legacy rows as JSON, e.g. [{"Emp ID":"E1","Name":"Alice","Email":"alice@x.com","Dept":"Sales","Birthday":"06-27"}]'
        rows={5}
        style={{ width: "100%", boxSizing: "border-box", ...inputStyle, fontFamily: "ui-monospace,Menlo,monospace", fontSize: 12 }}
      />

      {error && <div style={{ marginTop: 10 }}><Banner tone="danger">{error}</Banner></div>}

      {s && (
        <div style={{ marginTop: 14 }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))", gap: 10, marginBottom: 10 }}>
            <KPI label="Legacy rows" value={s.total_legacy_rows} />
            <KPI label="Nexus candidates" value={s.total_nexus_candidates} />
            <KPI label="Matched" value={s.matched} color={C.success} />
            <KPI label="Mismatched" value={s.mismatched} color={s.mismatched ? C.error : undefined} />
            <KPI label="Nexus only" value={s.nexus_only} />
            <KPI label="Legacy only" value={s.legacy_only} />
            <KPI label="Invalid legacy" value={s.invalid_legacy} />
            <KPI label="Review rows" value={s.review_rows} />
          </div>
          <Banner tone={s.mismatched || s.nexus_only || s.legacy_only || s.invalid_legacy ? "warn" : "success"}>
            {s.recommendation}
          </Banner>
        </div>
      )}
    </Section>
  );
}
